import { useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Button } from "reactstrap";

export default function ModalConfirmDeleteAll(props) {
  const { isOpen, toggle, title = "", onConfirm } = props;
  const [textConfirm, setTextConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  async function confirmDelete() {
    try {
      setLoading(true);
      await onConfirm();
    } finally {
      setLoading(false);
      toggle();
    }
  }

  return (
    <>
      <Modal centered isOpen={isOpen}>
        <ModalHeader toggle={toggle}>
          {title || "Confirmar limpar todos"}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <label className="form-label">
                Escreva{" "}
                <span style={{ color: "red", fontWeight: "bolder" }}>
                  "sim, desejo deletar"
                </span>{" "}
                e confirme para deletar
              </label>
              <input
                className="form-control"
                type="text"
                onChange={(e) => setTextConfirm(e.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col
              md={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                className="btn-danger"
                style={{ backgroundColor: loading ? "darkgray" : "#f36a6a" }}
                disabled={textConfirm !== "sim, desejo deletar"}
                onClick={() => {
                  if (onConfirm && !loading) confirmDelete();
                }}
              >
                {loading ? "Deletando" : "Confirmar"}
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}
